  function initializeCartSwatches() {
    // Initialize color swatch functionality for cart drawer products
    const cartSwatches = document.querySelectorAll('.cart-drawer__recommendations .variant-swatch, .cart-complete-look-section .variant-swatch');
    
    cartSwatches.forEach(function (swatch) {
      // Remove existing event listeners to prevent duplicates
      swatch.removeEventListener('click', handleImageClick);
      swatch.removeEventListener('click', handleCartSwatchClick);
      
      // Add event listeners
      if (typeof handleImageClick === 'function') {
        swatch.addEventListener('click', handleImageClick);
      } else {
        swatch.addEventListener('click', handleCartImageClick);
      }
      swatch.addEventListener('click', handleCartSwatchClick);
    });
    // Note: Complete look swatch handlers use event delegation on body, no need to reinitialize
  }

  function handleCartImageClick(event) {
    // Fallback image click handler for cart products
    const swatch = event.target.closest('.variant-swatch');
    if (!swatch) return;

    const swatchElement = swatch.querySelector('.swatch');
    if (!swatchElement) return;

    const dataSrc = swatchElement.getAttribute('data-src');
    const dataUrl = swatchElement.getAttribute('data-url');
    const dataQty = swatchElement.getAttribute('data-qty');
    const dataPrice = swatchElement.getAttribute('data-price');
    const dataSalePrice = swatchElement.getAttribute('data-sale-price');

    if (dataSrc && dataUrl) {
      // Use global function if available, otherwise use local fallback
      if (typeof updateCardMediaAndPrice === 'function') {
        updateCardMediaAndPrice(event, dataSrc, dataUrl, dataQty, dataPrice, dataSalePrice);
      } else {
        updateCartCardMediaAndPrice(event, dataSrc, dataUrl, dataQty, dataPrice, dataSalePrice);
      }
    }
  }

  function updateCartCardMediaAndPrice(event, dataSrc, dataUrl, dataQty, dataPrice, dataSalePrice) {
    // Fallback function to update card media and price
    const cardInner = event.target.closest('.card');
    if (!cardInner) return;

    const anchor = cardInner.querySelector('a');
    const media = cardInner.querySelector('img');
    let priceContainer = cardInner.querySelector('.price__container'); 
    let priceHTML = "";

    if (media) media.src = dataSrc;
    if (anchor) anchor.href = dataUrl;
      
    if (dataSalePrice) {
      // Generate sale price HTML
      priceHTML = `
        <div class="price__sale">
          <span>
            <s class="price-item price-item--regular">${dataSalePrice}</s>
          </span>
          <span class="price-item price-item--sale price-item--last">
            ${dataPrice}
          </span>
        </div>
      `;
    } else {
      // Generate regular price HTML
      priceHTML = `
        <div class="price__regular">
          <span class="price-item price-item--regular">
            ${dataPrice}
          </span>
        </div>
      `;
    }

    if (priceContainer) {
      priceContainer.innerHTML = priceHTML;
    }
  }

  function handleCartSwatchClick(event) {
    // Handle swatch clicks specifically for cart products
    const swatch = event.target.closest('.variant-swatch');
    if (!swatch) return;

    // Set active class on the clicked swatch
    if (typeof setActiveClass === 'function') {
      setActiveClass(swatch);
    } else {
      // Fallback if setActiveClass is not available
      const siblings = swatch.parentElement.children;
      for (let sibling of siblings) {
        if (sibling !== swatch) {
          sibling.classList.remove('active');
        }
      }
      swatch.classList.add('active');
    }
  }

  function initializeCartRecommendationsDrag() {
    // Initialize color swatches for cart recommendations and complete look products
    initializeCartSwatches();

     
    // Add mobile-like drag functionality to cart drawer recommendations on desktop
    const recommendationsLists = document.querySelectorAll('.cart-drawer__recommendations .horizontal-scroll-list, .cart-complete-look-section .horizontal-scroll-list');
    
    recommendationsLists.forEach(recommendationsList => {
      if (recommendationsList && window.innerWidth >= 750) {
      let isDown = false;
      let startX;
      let scrollLeft;
      let velocity = 0;
      let momentum = 0;
      let lastX = 0;
      let lastTime = 0;
      let animationId;
      
      // Momentum scrolling function
      function momentumScroll() {
        if (Math.abs(momentum) > 0.5) {
          recommendationsList.scrollLeft += momentum;
          momentum *= 0.95; // Friction
          animationId = requestAnimationFrame(momentumScroll);
        }
      }
      
      recommendationsList.addEventListener('mousedown', (e) => {
        isDown = true;
        recommendationsList.classList.add('dragging');
        recommendationsList.style.scrollBehavior = 'auto';
        startX = e.pageX - recommendationsList.offsetLeft;
        scrollLeft = recommendationsList.scrollLeft;
        lastX = e.pageX;
        lastTime = Date.now();
        velocity = 0;
        momentum = 0;
        
        // Cancel any ongoing momentum
        if (animationId) {
          cancelAnimationFrame(animationId);
        }
        
        e.preventDefault();
      });
      
      recommendationsList.addEventListener('mouseleave', () => {
        if (isDown) {
          isDown = false;
          recommendationsList.classList.remove('dragging');
          recommendationsList.style.scrollBehavior = 'smooth';
          
          // Start momentum scrolling
          momentum = velocity * 15; // Amplify velocity for momentum
          momentumScroll();
        }
      });
      
      recommendationsList.addEventListener('mouseup', () => {
        if (isDown) {
          isDown = false;
          recommendationsList.classList.remove('dragging');
          recommendationsList.style.scrollBehavior = 'smooth';
          
          // Start momentum scrolling
          momentum = velocity * 15; // Amplify velocity for momentum
          momentumScroll();
        }
      });
      
      recommendationsList.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        
        const x = e.pageX - recommendationsList.offsetLeft;
        const currentTime = Date.now();
        const deltaTime = currentTime - lastTime;
        const deltaX = e.pageX - lastX;
        
        // Calculate velocity
        if (deltaTime > 0) {
          velocity = deltaX / deltaTime;
        }
        
        // Apply scroll with 1:1 ratio like mobile
        const walk = x - startX;
        recommendationsList.scrollLeft = scrollLeft - walk;
        
        lastX = e.pageX;
        lastTime = currentTime;
      });
      
      // Prevent click events when dragging
      recommendationsList.addEventListener('click', (e) => {
        if (recommendationsList.classList.contains('dragging')) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
      
      }
    });
  }

  // Store the latest added variant ID
  window.latestAddedVariantId = null;
  
  // Listen for cart update events to track latest added item
  if (typeof subscribe !== 'undefined') {
    subscribe('cartUpdate', (event) => {
      if (event.productVariantId) {
        window.latestAddedVariantId = event.productVariantId;
        localStorage.setItem('latestAddedVariantId', event.productVariantId);
        
        // Set flag to force recommendations refresh
        localStorage.setItem('forceRecommendationsRefresh', 'true');
        
        // Trigger complete look section update after a short delay to ensure cart drawer has updated
        setTimeout(() => {
          const needsRefresh = checkIfCompleteLookNeedsRefresh(event.productVariantId);
          if (needsRefresh) {
            forceCartDrawerRecommendationsRefresh();
          } else {
            updateCompleteLoookFromLatestItem();
          }
        }, 800); // Increased delay for cart drawer refresh
      }
      
      // Update "You may also love" recommendations for both additions and removals
      if (event.cartData && typeof window.updateDynamicRecommendations === 'function') {
        setTimeout(() => {
          window.updateDynamicRecommendations(event.cartData);
        }, 600); // Delay to ensure cart drawer has updated
      }
    });
  }
  
  function checkIfCompleteLookNeedsRefresh(newVariantId) {
    const finder = document.getElementById('complete-look-item-finder');
    const completeLookSection = document.querySelector('.cart-complete-look-section');
    
    if (!finder || !completeLookSection) return true;
    
    // Check if new item has complete look capability
    let newItem = finder.querySelector(`[data-variant-id="${newVariantId}"][data-has-complete-look="true"]`);
    if (!newItem) {
      const latestItem = finder.querySelector(`[data-variant-id="${newVariantId}"]`);
      if (latestItem) {
        const productId = latestItem.getAttribute('data-product-id');
        newItem = finder.querySelector(`[data-product-id="${productId}"][data-has-complete-look="true"]`);
      }
    }
    
    if (!newItem) return false; // New item doesn't have complete look
    
    // Check if complete look section is for a different product
    const newProductId = newItem.getAttribute('data-product-id');
    const currentProductId = completeLookSection.getAttribute('data-product-id');
    
    return newProductId !== currentProductId;
  }
  
  function forceCartDrawerRecommendationsRefresh() {
    // Force a complete refresh of cart drawer content
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents();
    } else {
      // Fallback: close and reopen cart drawer
      setTimeout(() => {
        if (cartDrawer && typeof cartDrawer.close === 'function') {
          cartDrawer.close();
          setTimeout(() => {
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          }, 100);
        }
      }, 200);
    }
  }
  
  // Initialize on page load
  document.addEventListener('DOMContentLoaded', initializeCartRecommendationsDrag);
  
  // Re-initialize after cart updates
  document.addEventListener('cartRecommendationsUpdated', initializeCartRecommendationsDrag);
  
  // Also listen for cart drawer updates to refresh complete look section
  document.addEventListener('cart:updated', () => {
    setTimeout(() => {
      updateCompleteLoookFromLatestItem();
    }, 300);
  });
  
  // Function to update complete look from latest item
  function updateCompleteLoookFromLatestItem() {
    const latestVariantId = localStorage.getItem('latestAddedVariantId');
    if (latestVariantId && typeof window.updateCompleteLookSection === 'function') {
      const finder = document.getElementById('complete-look-item-finder');
      if (finder) {
        let targetItem = finder.querySelector(`[data-variant-id="${latestVariantId}"][data-has-complete-look="true"]`);
        
        if (!targetItem) {
          const latestItem = finder.querySelector(`[data-variant-id="${latestVariantId}"]`);
          if (latestItem) {
            const productId = latestItem.getAttribute('data-product-id');
            targetItem = finder.querySelector(`[data-product-id="${productId}"][data-has-complete-look="true"]`);
          }
        }
        
        if (targetItem) {
          const productId = targetItem.getAttribute('data-product-id');
            const productHandle = targetItem.getAttribute('data-product-handle');
            window.updateCompleteLookSection(productId, latestVariantId, productHandle);
          }
      }
    }
  }
  
  // Re-initialize drag functionality after cart drawer updates
  function reinitializeCartDrawer() {
    setTimeout(() => {
      initializeCartRecommendationsDrag();
    }, 300);
  }
  
  // Setup re-initialization when DOM is ready
  document.addEventListener('DOMContentLoaded', reinitializeCartDrawer);
  
  // Re-initialize after cart updates
  document.addEventListener('cart:updated', reinitializeCartDrawer);
  
  // updateDynamicRecommendations function is now loaded globally via cart-recommendations.js
  
  
  // Event listeners are now set up globally in cart-recommendations.js
  
  
  // Helper function to show/hide products based on color
  function showProductsForColor(productsList, color) {
    const allItems = productsList.querySelectorAll('.grid__item');
    allItems.forEach(item => {
      const itemSourceColor = item.getAttribute('data-source-color');
      if (itemSourceColor === color) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });
  }
  
  // Make updateCompleteLookSection globally available
  window.updateCompleteLookSection = function(productId, variantId, productHandle) {
    const completeLookSection = document.querySelector('.cart-complete-look-section');
    
    if (!completeLookSection) {
      // If section doesn't exist, create it
      createCompleteLookSection(productId, variantId, productHandle);
      return;
    }
    
    const variantsData = document.querySelector('.complete-look-variants-data');
    const productsList = document.getElementById('complete-look-products-list');
    
    if (!variantsData || !productsList) {
      // Regenerate the complete look section with new data
      regenerateCompleteLookSection(productId, variantId, productHandle);
      return;
    }
    
    // Check if we need to regenerate for a different product
    const currentProductId = completeLookSection.getAttribute('data-product-id');
    const currentDisplayedColor = completeLookSection.getAttribute('data-current-color');
    
    if (currentProductId !== productId) {
      regenerateCompleteLookSection(productId, variantId, productHandle);
      return;
    }
    
    // Show the section
    completeLookSection.classList.remove('no-js-hidden');
    completeLookSection.setAttribute('data-product-id', productId);
    
    // Find the variant data for the current variant
    let variantData = variantsData.querySelector(`[data-variant-id="${variantId}"]`);
    let currentColor = null;
    
    if (!variantData) {
      // Exact variant not found, try to find variant by color
      // First, we need to determine the color of the added variant
      // Check the finder to get the color information
      const finder = document.getElementById('complete-look-item-finder');
      if (finder) {
        const addedItem = finder.querySelector(`[data-variant-id="${variantId}"]`);
        if (addedItem) {
          // Get the product's variants to find the color
          fetch(`${window.Shopify?.routes?.root || '/'}products/${productHandle}.js`)
            .then(response => response.json())
            .then(productData => {
              const addedVariant = productData.variants.find(v => v.id == variantId);
              
              if (addedVariant && addedVariant.option1) {
                // option1 is typically the color
                const variantColor = addedVariant.option1;
                
                // Re-query the current state in case DOM has updated
                const currentCompleteLookSection = document.querySelector('.cart-complete-look-section');
                const currentVariantsData = document.querySelector('.complete-look-variants-data');
                const currentProductsList = document.getElementById('complete-look-products-list');
                
                if (!currentCompleteLookSection || !currentVariantsData || !currentProductsList) {
                  // Section was removed, regenerate
                  regenerateCompleteLookSection(productId, variantId, productHandle);
                  return;
                }
                
                // Find any variant with this color that has complete look data
                const colorVariantData = currentVariantsData.querySelector(`[data-color="${variantColor}"]`);
                
                if (colorVariantData) {
                  // Get which variant has the complete look data
                  const variantIdWithData = colorVariantData.getAttribute('data-variant-id');
                  
                  // Color has complete look data, check if products are already rendered from the correct source variant
                  const productsForThisVariant = currentProductsList.querySelectorAll(`[data-source-variant="${variantIdWithData}"]`);
                  
                  if (productsForThisVariant.length > 0) {
                    // Products are already rendered from the correct variant, just show them
                    showProductsForColor(currentProductsList, variantColor);
                    currentCompleteLookSection.classList.remove('no-js-hidden');
                    currentCompleteLookSection.style.display = ''; // Reset display style
                    currentCompleteLookSection.setAttribute('data-current-color', variantColor); // Store current color
                  } else {
                    // Products not rendered from the correct variant, need to regenerate the section
                    if (window.skipRegenerationOnce) {
                      window.skipRegenerationOnce = false;
                      currentCompleteLookSection.classList.remove('no-js-hidden');
                      currentCompleteLookSection.style.display = '';
                    } else {
                      regenerateCompleteLookSection(productId, variantId, productHandle);
                    }
                  }
                } else {
                  // No variant found with this color's complete look data, hide the section
                  currentCompleteLookSection.classList.add('no-js-hidden');
                  currentCompleteLookSection.style.display = 'none';
                  currentCompleteLookSection.removeAttribute('data-current-color'); // Clear stored color
                }
              } else {
                // Can't determine color, hide the section
                const currentCompleteLookSection = document.querySelector('.cart-complete-look-section');
                if (currentCompleteLookSection) {
                  currentCompleteLookSection.classList.add('no-js-hidden');
                  currentCompleteLookSection.style.display = 'none';
                  currentCompleteLookSection.removeAttribute('data-current-color'); // Clear stored color
                }
              }
            })
            .catch(error => {
              console.error('Error fetching product data:', error);
              // On error, hide the section
              const currentCompleteLookSection = document.querySelector('.cart-complete-look-section');
              if (currentCompleteLookSection) {
                currentCompleteLookSection.classList.add('no-js-hidden');
                currentCompleteLookSection.style.display = 'none';
                currentCompleteLookSection.removeAttribute('data-current-color'); // Clear stored color
              }
            });
        } else {
          // Can't find item in finder, check if product changed
          if (currentProductId !== productId) {
            regenerateCompleteLookSection(productId, variantId, productHandle);
          } else {
            // Hide section if we can't determine what to show
            completeLookSection.classList.add('no-js-hidden');
            completeLookSection.style.display = 'none';
            completeLookSection.removeAttribute('data-current-color'); // Clear stored color
          }
        }
      } else {
        // No finder element, regenerate
        regenerateCompleteLookSection(productId, variantId, productHandle);
      }
      return;
    }
    
    currentColor = variantData.getAttribute('data-color');
    const completeVariants = variantData.querySelectorAll('[data-complete-variant-id]');
    
    // Check if products are rendered from this specific variant
    const productsForThisVariant = productsList.querySelectorAll(`[data-source-variant="${variantId}"]`);
    
    if (productsForThisVariant.length === 0) {
      // Products not rendered from this variant, regenerate the section
      if (window.skipRegenerationOnce) {
        window.skipRegenerationOnce = false;
        completeLookSection.classList.remove('no-js-hidden');
        completeLookSection.style.display = '';
      } else {
        regenerateCompleteLookSection(productId, variantId, productHandle);
        return;
      }
    }
    
    // Check if color has changed - if yes, update the displayed products
    if (currentDisplayedColor !== currentColor) {
      // Color changed, update products for new color
      showProductsForColor(productsList, currentColor);
      completeLookSection.setAttribute('data-current-color', currentColor); // Update stored color
    }
    
    // Ensure the section is visible
    completeLookSection.classList.remove('no-js-hidden');
    completeLookSection.style.display = ''; // Reset display style
    
    // Update the section heading or any product-specific content
    const heading = completeLookSection.querySelector('.related-products__heading');
    if (heading) {
      heading.textContent = 'Complete The Look';
    }
  };
  
  function createCompleteLookSection(productId, variantId, productHandle) {
    const recommendationsContainer = document.querySelector('.cart-drawer__recommendations');
    if (!recommendationsContainer) return;
    
    // Check if section already exists (prevent duplicates)
    const existingSection = document.querySelector('.cart-complete-look-section');
    if (existingSection) {
      return;
    }
    
    // Create the complete look section
    const section = document.createElement('div');
    section.className = 'related-products cart-complete-look-section no-js-hidden';
    section.setAttribute('data-product-id', productId);
    section.innerHTML = `
      <h2 class="related-products__heading inline-richtext h2">Complete The Look</h2>
      <div class="complete-look-variants-data" style="display: none;"></div>
      <ul class="horizontal-scroll-list custom-realted-product-grid changeable-grid grid product-grid grid--2-col-tablet-down grid--2-col-desktop" 
          style="margin-top:0" id="complete-look-products-list">
      </ul>
    `;
    
    // Insert before the "You may also love" section
    const youMayLoveSection = recommendationsContainer.querySelector('.related-products:not(.cart-complete-look-section)');
    if (youMayLoveSection) {
      recommendationsContainer.insertBefore(section, youMayLoveSection);
    } else {
      recommendationsContainer.appendChild(section);
    }
    
    // Now regenerate with proper content
    regenerateCompleteLookSection(productId, variantId, productHandle);
  }
  
  function regenerateCompleteLookSection(productId, variantId, productHandle, skipUpdateAfter = false) {
    // Set a flag to prevent infinite loops
    if (window.regeneratingCompleteLoook) {
      return;
    }
    window.regeneratingCompleteLoook = true;
    
    // Just reload the cart drawer to get fresh complete look
    // Server-side rendering has full access to metafields
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cart => {
          // Fetch sections with cart context
          return fetch(window.Shopify.routes.root + 'cart?sections=cart-drawer')
        })
        .then(response => response.json())
        .then(sections => {
          if (sections && sections['cart-drawer']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
            const newRecommendations = doc.querySelector('.cart-drawer__recommendations');
            const currentRecommendations = document.querySelector('.cart-drawer__recommendations');
            
            if (newRecommendations && currentRecommendations) {
              currentRecommendations.innerHTML = newRecommendations.innerHTML;
              
              setTimeout(() => {
                initializeCartRecommendationsDrag();
                
                const completeLookSection = document.querySelector('.cart-complete-look-section');
                if (completeLookSection) {
                  completeLookSection.classList.remove('no-js-hidden');
                }
                
                // After regeneration, call updateCompleteLookSection to ensure correct variant products are shown
                // Only if skipUpdateAfter is false
                if (!skipUpdateAfter) {
                  // Add extra delay to ensure DOM is fully updated
                  setTimeout(() => {
                    window.regeneratingCompleteLoook = false; // Reset flag
                    
                    if (typeof window.updateCompleteLookSection === 'function') {
                      // Set a temporary flag to prevent regeneration from being called again during this update
                      window.skipRegenerationOnce = true;
                      window.updateCompleteLookSection(productId, variantId, productHandle);
                      // Flag will be cleared in updateCompleteLookSection
                    }
                  }, 200);
                } else {
                  window.regeneratingCompleteLoook = false;
                }
              }, 300);
            } else {
              window.regeneratingCompleteLoook = false;
            }
          } else {
            window.regeneratingCompleteLoook = false;
          }
        })
        .catch(error => {
          window.regeneratingCompleteLoook = false;
        });
    } else {
      window.regeneratingCompleteLoook = false;
    }
  };
